export default function Line() {
    return <img src="/images/line.png" className="p-0" width="100%" height="0.5px" />;
}